export const LOADED = 'LOADED'
export const LOADING = 'LOADING'
export const SET_ERROR = 'SET_ERROR'
export const CLEAR_ERROR = 'CLEAR_ERROR'
export const CHANGE_MODAL_VISIBILITY = 'CHANGE_MODAL_VISIBILITY'
export const SET_CHOOSEN_VOICE = 'SET_CHOOSEN_VOICE'
export const SET_MODAL_TYPE = 'SET_MODAL_TYPE'
